module.exports = __webpack_public_path__ + "img/leavetest.f87994c0.svg";